import moment from 'moment';
import { DISPLAY_DATE_TIME_FORMAT, API_DATE_TIME_FORMAT, JAVASCRIPT_DATE_FORMAT } from '../../constants';

const toApiDateTimeFormat = date => {
	if (!date || !moment(date).isValid()) {
		return null;
	}
	return moment(date).format(API_DATE_TIME_FORMAT);
};

const toDisplayDateTimeFormat = date => {
	if (!date || !moment(date).isValid()) {
		return null;
	}
	return moment(date).format(DISPLAY_DATE_TIME_FORMAT);
};

const toJavaScriptDateFormat = date => {
	if (!date || !moment(date).isValid()) {
		return null;
	}
	const result = moment(date).format(JAVASCRIPT_DATE_FORMAT);
	return result;
};

export { toApiDateTimeFormat, toDisplayDateTimeFormat, toJavaScriptDateFormat };
